import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Confirm from './confirm';
import Modal from 'components/modal';
import Success from './success';
import { post } from 'helpers/api';

import './styles.scss';

export default function CreateModal({ deal, path, show, onCancel, onSave }) {
  const [creating, setCreating] = useState();
  const [error, setError] = useState();

  function reset() {
    setError(null);
  }

  async function createVoucher() {
    try {
      setCreating(true);
      const voucher = await post(path, { dealId: deal.id });
      if (voucher) {
        onSave({ voucher });
      }
    } catch (e) {
      setCreating(false);
      setError(e);
    }
  }

  return (
    <Modal
      backdrop="static"
      className="apex-voucher-creation-modal"
      show={show}
      onHide={onCancel}
      onShow={reset}
    >
      {deal.voucher
        ? <Success deal={deal} onCancel={onCancel} />
        : <Confirm creating={creating} deal={deal} error={error} onCancel={onCancel} onCreate={createVoucher} />
      }
    </Modal>
  );
}

CreateModal.propTypes = {
  deal: PropTypes.shape({
    id: PropTypes.number.isRequired,
    dealTypeLabel: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    voucher: PropTypes.object,
  }).isRequired,
  path: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
